// Mock data for ServicePlyus website

export const siteInfo = {
  name: "ServicePlyus",
  phone: "+998 92 070 54 54",
  phoneLink: "tel:+998920705454",
  telegram: "https://t.me/Umidserviceplyus",
  telegramUsername: "@Umidserviceplyus",
  instagram: "https://instagram.com/serviceplyus",
  workingHours: "24/7",
  serviceArea: "Xizmat faqat Toshkent shahri bo'yicha"
};

export const heroContent = {
  title: "Katyol remont va texnik xizmat",
  subtitle: "Toshkent bo'ylab tez va ishonchli katyol ta'mirlash xizmati",
  description: "Barcha turdagi katyollarni professional ta'mirlash, diagnostika va texnik xizmat ko'rsatish",
  image: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg"
};

export const advantages = [
  {
    id: 1,
    title: "Katta tajriba",
    description: "10+ yillik tajriba bilan barcha turdagi katyollarni ta'mirlaymiz",
    icon: "Award"
  },
  {
    id: 2,
    title: "Kafolat xizmati",
    description: "Barcha ishlarimizga 6 oylik kafolat beramiz",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Tezkor xizmat",
    description: "24/7 ish tartibi, arizangizga 1 soat ichida javob beramiz",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Adolatli narxlar",
    description: "Bozordagi eng maqbul narxlarda sifatli xizmat",
    icon: "DollarSign"
  }
];

export const boilerBrands = [
  { 
    id: 1, 
    name: "Airfel", 
    slug: "airfel",
    description: "Airfel - Turkiya ishlab chiqargan yuqori sifatli katyollar. Uzoq xizmat muddati va ishonchlilik bilan mashhur.",
    commonProblems: [
      "Bosim tushib qolishi",
      "Issiqlik almashinuvchi tiqilib qolishi",
      "Elektronika nosozligi",
      "Suv nasosi ishlamay qolishi"
    ],
    image: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2"
  },
  { 
    id: 2, 
    name: "Akfa", 
    slug: "akfa",
    description: "Akfa - O'zbekistonda mashhur turkcha katyol brendi. Mahalliy iqlim sharoitlariga moslashtirilgan.",
    commonProblems: [
      "Shamni almashtirish kerak",
      "Sirkulyatsiya nasosi buzilishi",
      "Elektronika platasining nosozligi",
      "Gaz klapani buzilishi"
    ],
    image: "https://images.unsplash.com/photo-1618826470964-f6f8b3ae52aa"
  },
  { 
    id: 3, 
    name: "Atlantic", 
    slug: "atlantic",
    description: "Atlantic - Frantsuz ishlab chiqaruvchisi. Zamonaviy texnologiya va ekologik toza ishlash.",
    commonProblems: [
      "Termoblok almashtirish",
      "Bosim sensori buzilishi",
      "Suv oqishi muammosi",
      "Ekran xatoliklari"
    ],
    image: "https://images.unsplash.com/photo-1658758904121-ee49fc5e205c"
  },
  { 
    id: 4, 
    name: "Baxi", 
    slug: "baxi",
    description: "Baxi - Italyan premium katyollari. Yuqori samaradorlik va chiroyli dizayn bilan ajralib turadi.",
    commonProblems: [
      "Issiqlik almashgich tozalash",
      "Uch pozitsiyali klapan almashtirish",
      "Ekspanziya idishi bosimi",
      "Turbo ventilyatori nosozligi"
    ],
    image: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg"
  },
  { 
    id: 5, 
    name: "Baymak", 
    slug: "baymak",
    description: "Baymak - Turkiya katyollari. Oddiy xizmat ko'rsatish va ishonchli ishlash.",
    commonProblems: [
      "Gaz valve almashtirish",
      "PCB board ta'mirlash",
      "Fan motor almashtirish",
      "Suv bosimi muammolari"
    ],
    image: "https://images.pexels.com/photos/7736158/pexels-photo-7736158.jpeg"
  },
  { 
    id: 6, 
    name: "Ferroli", 
    slug: "ferroli",
    description: "Ferroli - Italyan sifatli katyollar. Zamonaviy kondensatsion texnologiyalar.",
    commonProblems: [
      "Yonish kamerasi tozalash",
      "NTC sensorlar almashtirish",
      "Diverter valve ta'mirlash",
      "Bosim o'zgarishi"
    ],
    image: "https://images.unsplash.com/photo-1758873263491-f3969d8c6fda"
  },
  { 
    id: 7, 
    name: "Rulls", 
    slug: "rulls",
    description: "Rulls - Zamonaviy turkcha brend. Qulay narx va yaxshi sifat kombinatsiyasi.",
    commonProblems: [
      "Sham yoqish muammosi",
      "Suv oqishi",
      "Ekran xatolari",
      "Sirkulyatsiya ta'mirlash"
    ],
    image: "https://images.pexels.com/photos/33813584/pexels-photo-33813584.jpeg"
  },
  { 
    id: 8, 
    name: "Kiturami", 
    slug: "kiturami",
    description: "Kiturami - Koreya ishlab chiqargan yuqori texnologiyali katyollar. Sovuq iqlimga bardoshli.",
    commonProblems: [
      "Elektronika diagnostikasi",
      "Gaz pressostati almashtirish",
      "Suv filtri tozalash",
      "Xavfsizlik klapani almashtirish"
    ],
    image: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2"
  },
  { 
    id: 9, 
    name: "Unit", 
    slug: "unit",
    description: "Unit - Arzon va ishonchli turkcha katyollar. O'rta narx segmentida yetakchi.",
    commonProblems: [
      "Bosim ko'rsatkichi nosozligi",
      "Nasosning tovush chiqarishi",
      "Termostat almashtirish",
      "Havo chiqarish muammosi"
    ],
    image: "https://images.unsplash.com/photo-1618826470964-f6f8b3ae52aa"
  },
  { 
    id: 10, 
    name: "Viessmann", 
    slug: "viessmann",
    description: "Viessmann - Nemis premium katyollari. Eng yuqori samaradorlik va chidamlilik.",
    commonProblems: [
      "Lambda sensor tozalash",
      "Modulyatsiya klapani sozlash",
      "Kondensatsiya drenaji",
      "Smart diagnostika xatoliklari"
    ],
    image: "https://images.unsplash.com/photo-1658758904121-ee49fc5e205c"
  },
  { 
    id: 11, 
    name: "Everel", 
    slug: "everel",
    description: "Everel - Turkiya brendi. Oddiy dizayn va oson xizmat ko'rsatish imkoniyati.",
    commonProblems: [
      "Gaz valve diagnostika",
      "Suv nasosi ta'mirlash",
      "Ekran muammolari",
      "Shamchalar almashtirish"
    ],
    image: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg"
  },
  { 
    id: 12, 
    name: "Thermona", 
    slug: "thermona",
    description: "Thermona - Chexiya katyollari. Evropa sifati va ishonchli ishlash.",
    commonProblems: [
      "Mantolama tozalash",
      "Termik himoya almashtirish",
      "Gaz bosimi sozlash",
      "Avtomatika nosozligi"
    ],
    image: "https://images.pexels.com/photos/7736158/pexels-photo-7736158.jpeg"
  },
  { 
    id: 13, 
    name: "Navien", 
    slug: "navien",
    description: "Navien - Janubiy Koreya premium katyollari. Zamonaviy smart texnologiyalar bilan.",
    commonProblems: [
      "Smart control sozlash",
      "Suv oqimi sensori",
      "Alanga sensori almashtirish",
      "PCB ta'mirlash"
    ],
    image: "https://images.unsplash.com/photo-1758873263491-f3969d8c6fda"
  },
  { 
    id: 14, 
    name: "Orbek", 
    slug: "orbek",
    description: "Orbek - Turkiya katyollari. Mahalliy bozorda mashhur va arzon ehtiyot qismlar.",
    commonProblems: [
      "Shamchani almashtirish",
      "Suv bosimi tiklash",
      "Ventilyator ta'mirlash",
      "Elektronika diagnostika"
    ],
    image: "https://images.pexels.com/photos/33813584/pexels-photo-33813584.jpeg"
  }
];

export const services = [
  {
    id: 1,
    slug: "diagnostika",
    icon: "Search",
    image: "https://images.pexels.com/photos/7859953/pexels-photo-7859953.jpeg"
  },
  {
    id: 2,
    slug: "tozalash",
    icon: "Droplets",
    image: "https://images.pexels.com/photos/7736158/pexels-photo-7736158.jpeg"
  },
  {
    id: 3,
    slug: "uch-klapan",
    icon: "Settings",
    image: "https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2"
  },
  {
    id: 4,
    slug: "turbina",
    icon: "Fan",
    image: "https://images.unsplash.com/photo-1618826470964-f6f8b3ae52aa"
  },
  {
    id: 5,
    slug: "issiqlik-almashgich",
    icon: "Flame",
    image: "https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg"
  },
  {
    id: 6,
    slug: "bosim-sensori",
    icon: "Gauge",
    image: "https://images.unsplash.com/photo-1658758904121-ee49fc5e205c"
  },
  {
    id: 7,
    slug: "manostat",
    icon: "Wind",
    image: "https://images.pexels.com/photos/8478264/pexels-photo-8478264.jpeg"
  },
  {
    id: 8,
    slug: "shoshilinch",
    icon: "AlertTriangle",
    image: "https://images.pexels.com/photos/33813584/pexels-photo-33813584.jpeg"
  }
];

export const aboutContent = {
  title: "ServicePlyus haqida",
  description: "ServicePlyus - Toshkent shahrida katyol ta'mirlash bo'yicha etakchi kompaniya. Bizning jamoamiz 10 yildan ortiq tajribaga ega professional ustalardan iborat.",
  features: [
    "10+ yillik tajriba",
    "Malakali mutaxassislar jamoasi",
    "Barcha brendlarni ta'mirlash",
    "Kafolat xizmati",
    "24/7 qo'llab-quvvatlash",
    "Tezkor xizmat"
  ],
  whyUs: [
    {
      title: "Professional yondashuv",
      description: "Har bir mijozga individual yondashish va sifatli xizmat ko'rsatish"
    },
    {
      title: "Ishonchli xizmat",
      description: "Mijozlarimizning 95% dan ortig'i bizni do'stlariga tavsiya qiladi"
    },
    {
      title: "Samarali yechimlar",
      description: "Eng qisqa muddatda va optimal narxlarda muammolarni hal qilamiz"
    }
  ],
  image: "https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg"
};

// Mock form submission
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Arizangiz qabul qilindi! Tez orada aloqaga chiqamiz." });
    }, 1000);
  });
};
